export default "__VITE_ASSET__cf001057__"